/* You Will Rock — site chrome behaviour. The header's localization menus are native
   <details>, so this only adds the full-page menu drawer and the outside-click niceties. */
(function () {
  if (window.__ywrSiteLoaded) return;
  window.__ywrSiteLoaded = true;

  /* ---------- full-page menu drawer ---------- */
  var burger = document.querySelector('[data-navburger]');
  var drawer = document.getElementById('ywr-navdrawer');
  if (burger && drawer) {
    var closers = drawer.querySelectorAll('[data-navclose]');
    var scrollY = 0;
    var open = false;

    function focusable() {
      return [].slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), summary, input, select, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null || el.tagName === 'SUMMARY'; });
    }

    function setOpen(next) {
      if (next === open) return;
      open = next;
      burger.setAttribute('aria-expanded', String(open));
      if (open) {
        scrollY = window.scrollY || window.pageYOffset || 0;
        drawer.hidden = false;
        /* lock the page behind the drawer without losing the scroll position */
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        var first = closers[0] || focusable()[0];
        if (first) first.focus();
      } else {
        drawer.hidden = true;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
        var returnFocus = burger.offsetParent !== null ? burger : document.querySelector('.nav-primary a');
        if (returnFocus) returnFocus.focus();
      }
    }

    burger.addEventListener('click', function () { setOpen(true); });
    [].forEach.call(closers, function (b) { b.addEventListener('click', function () { setOpen(false); }); });

    /* Switching to desktop navigation releases the mobile drawer and its scroll lock. */
    var desktopNav = window.matchMedia('(min-width: 901px)');
    desktopNav.addEventListener('change', function (event) {
      if (event.matches) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') { setOpen(false); return; }
      if (e.key !== 'Tab') return;
      /* keep focus inside the drawer while it owns the screen */
      var items = focusable();
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    });

    /* a link inside the drawer navigates: unlock the body so the next page scrolls normally */
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
      }
    });
  }

  /* ---------- localization dropdowns ---------- */
  var dds = [].slice.call(document.querySelectorAll('[data-site-dd]'));
  if (dds.length) {
    document.addEventListener('click', function (e) {
      dds.forEach(function (d) {
        if (d.open && !d.contains(e.target)) d.open = false;
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      dds.forEach(function (d) {
        if (d.open) {
          d.open = false;
          var s = d.querySelector('summary');
          if (s) s.focus();
        }
      });
    });
  }
})();
